// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__IgFvN","subheader":"Privacy_subheader__rFs9z","paragraph":"Privacy_paragraph__kD2zx","italicParagraph":"Privacy_italicParagraph__T0Uy4"};